import apiHandler from "../core/apiHandler";

const inventoryAdjustmentApi = apiHandler("inventory/adjustments");

export default inventoryAdjustmentApi;
